<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    圳美站<br>
站点介绍<br>
圳美站位于光侨路与圳美大道交叉口以南，沿光侨路南北布置，站点位置的光侨路地势呈南高北低，车站两端头位置路面高差约2m。车站周边主要为医疗、商业、居民和工业用地为主。西南侧为圳美社区，包括10层城佳科技城和6层圳美社区健康服务中心，9层的京林商务酒店，西北侧为圳美村，源泉百货以及华侨新村，东北侧为海鑫光工业园，深圳市科学研究院，东南侧为基本建成的中山大学第七附属医院。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:28	23:32	66号线	6分52秒	8-10分钟<br>
深理工	06:31	23:34	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:28	23:32	66号线	6分52秒	8-10分钟<br>
深理工	06:31	23:34	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:28	00:32	66号线	6分52秒	8-11分钟<br>
深理工	06:31	00:34	66号线	6分52秒	8-11分钟<br><br>
<br>
站点出口信息<br>
A出入口:<br>
光侨路东侧（南）、中山大学附属第七医院<br><br>
B出入口:<br>
光侨路东侧（北）、冠得利工业园、海鑫光高新技术工业园<br><br>
C出入口:<br>
光侨路西侧（北）、凯里亚德酒店<br><br>
D出入口:<br>
光侨路西侧（南）、城佳科技园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 中山七院换乘站①<br>
B901、B963、E3、M356、M411、莞747<br><br>
B出入口:<br>
公交站名： 圳美路口<br>
高峰专线113、莞747、325、B901、B963、E3、M356、M490<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxianzhixian",
          title: "6号线支线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>